import gql from "graphql-tag";

export const LoginAuthenticateUser = gql`
  mutation LoginAuthenticateUser($phone_number: String!, $code: String!) {
    solveLoginChallenge(data: { phone_number: $phone_number, code: $code }) {
      access_token
      refresh_token
    }
  }
`;

export const AuthenticateWithFacebook = gql`
  mutation AuthenticateWithFacebook($data: AuthenticateWithSocialMediaInput!) {
    authenticateWithFacebook(data: $data) {
      access_token
      refresh_token
    }
  }
`;

export const AuthenticateWithGoogle = gql`
  mutation AuthenticateWithGoogle($data: AuthenticateWithSocialMediaInput!) {
    authenticateWithGoogle(data: $data) {
      access_token
      refresh_token
    }
  }
`;

export const RefreshToken = gql`
  mutation RefreshToken($refresh_token: String!) {
    refreshToken(refresh_token: $refresh_token)
  }
`;

export const GetCurrentAppVersion = gql`
  query GetCurrentAppVersion($appType: AppTypeEnum!) {
    getCurrentAppVersion(appType: $appType) {
      androidVersion
      appType
      iosVersion
      webVersion
    }
  }
`;
